// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"408":"crawls-home","681":"crawl-single"}[chunkId] + "." + {"408":"9c2f60f3","681":"39017aef"}[chunkId] + ".css";
};